import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Flex} from '@travel-frontend/ui-components';

export const Body = styled(Flex)(
  ({theme}) => css`
    padding: 20px 0 0 0;

    ${theme.respondTo(
      'md',
      css`
        padding: 36px 24px 0 0;
      `
    )}

    ${theme.respondTo(
      'lg',
      css`
        /* stylelint-disable-next-line */
        padding: 115px 36px 0 0;
      `
    )}

    ${theme.respondTo(
      'xl',
      css`
        /* stylelint-disable-next-line */
        padding: 115px 100px 0 110px;
      `
    )}
  `
);
